import { cn } from "@/lib/utils";
import { TextareaHTMLAttributes, useState } from "react";
import { TypographyMuted } from "../typography/Muted";

interface Props extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  charLimitPlacement?: "left" | "right";
}

export const Textarea = ({
  className,
  charLimitPlacement = "left",
  ...props
}: Props) => {
  const [textLength, setTextLength] = useState(0);

  return (
    <div className="w-full">
      <textarea
        onChange={(e) => {
          props.onChange?.(e);
          setTextLength(e.currentTarget.textLength);
        }}
        className={cn(
          "relative flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-brand-primary disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        {...props}
      />
      {props.maxLength && (
        <TypographyMuted
          className={cn(
            "mt-1.5",
            charLimitPlacement === "right" && "block ml-auto mr-0 w-fit"
          )}
        >
          {textLength} / {props.maxLength}
        </TypographyMuted>
      )}
    </div>
  );
};
